import Chip from "@mui/material/Chip";
import { makeStyles } from "@mui/styles";
import React from "react";
import { SEMANTIC_RELEASE_VERSION } from "../util/versions";

const useStyles = makeStyles((theme) => ({
  chip: {
    [theme.breakpoints.down('md')]: {
      position: "fixed",
      fontSize: "10px",
      height: "16px",
    },
    [theme.breakpoints.down('sm')]: {
      position: "fixed",
      fontSize: "10px",
      height: "12px",
    },
    fontSize: "14px",
  },
  localChip: {
    backgroundColor: theme.palette.secondary.swaGreen,
    color: theme.palette.secondary.swaWhite,
  },
  devChip: {
    backgroundColor: theme.palette.primary.swaYellow,
    color: theme.palette.secondary.swaBlack,
  },
  qaChip: {
    backgroundColor: theme.palette.secondary.swaOrange,
    color: theme.palette.secondary.swaBlack,
  },
}));

const EnvironmentChip = () => {
  const classes = useStyles();

  const renderChip = (env, releaseVersion) => {
    if (env.toLowerCase().includes("local")) {
      return (
        <Chip className={`${classes.chip} ${classes.localChip}`} label={env + " - " + releaseVersion} size="small" />
      );
    } else if (env.toLowerCase() === "dev2") {
      return ""; // TODO: Remove this when SWAU work is complete, we want this environment displaying PROD-like for demo videos
    } else if (env.toLowerCase().includes("dev")) {
      return <Chip className={`${classes.chip} ${classes.devChip}`} label={env + " - " + releaseVersion} />;
    } else if (env.toLowerCase().includes("qa")) {
      return <Chip className={`${classes.chip} ${classes.qaChip}`} label={env + " - " + releaseVersion} />;
    } else {
      return "";
    }
  };

  return renderChip(process.env.REACT_APP_ENV, SEMANTIC_RELEASE_VERSION);
};

export default EnvironmentChip;
